<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit property' : 'Add property' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" id="property-form" (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Name</span>
        <input type="text" class="text-box-active" formControlName="name" />
      </div>

      <div class="field">
        <label class="field-label" id="property-category-label">Category</label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            aria-labelledby="property-category-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="category"
          >
            @for(opt of categoryOptions; track opt.value){
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <span class="field-label">Address</span>
      <input type="text" class="text-box-active" formControlName="address" />
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="property-pincode">Pincode</label>
        <div class="input-status-wrapper">
          <input
            id="property-pincode"
            type="text"
            class="text-box-active"
            formControlName="pincode"
            inputmode="numeric"
            autocomplete="postal-code"
            maxlength="6"
            aria-describedby="property-pincode-message"
          />
          @if(isPincodeLoading){
          <span class="lookup-spinner" aria-label="Checking pincode"></span>
          }
        </div>
        @if(pincodeControl?.touched && pincodeControl?.hasError('pattern')){
        <span id="property-pincode-message" class="field-message field-error">
          Enter a valid 6-digit pincode.
        </span>
        } @else if(pincodeLookupMessage){
        <span
          id="property-pincode-message"
          class="field-message"
          [class.field-error]="pincodeLookupStatus === 'error'"
          [class.field-success]="pincodeLookupStatus === 'valid'"
        >
          {{ pincodeLookupMessage }}
        </span>
        }
      </div>

      <div class="field">
        <label class="field-label" for="property-state">State</label>
        <input
          id="property-state"
          type="text"
          class="text-box-active readonly-field"
          formControlName="state"
          readonly
        />
      </div>

      <div class="field">
        <label class="field-label" id="property-district-label">District</label>
        @if(districtList.length > 1){
        <mat-form-field
          class="ac-select-field"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-select
            id="property-district"
            aria-labelledby="property-district-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="district"
            placeholder="Select district"
            (selectionChange)="onDistrictChange()"
          >
          @for(district of districtList; track district){
          <mat-option [value]="district">{{ district }}</mat-option>
          }
          </mat-select>
        </mat-form-field>
        } @else {
        <input
          aria-labelledby="property-district-label"
          type="text"
          class="text-box-active readonly-field"
          formControlName="district"
          readonly
        />
        }
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Landmark</span>
        <input type="text" class="text-box-active" formControlName="landmark" />
      </div>
      <div class="field">
        <span class="field-label">Location URL</span>
        <input type="text" class="text-box-active" formControlName="locationUrl" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Latitude (optional)</span>
        <input type="number" step="any" class="text-box-active" formControlName="latitude" />
      </div>
      <div class="field">
        <span class="field-label">Longitude (optional)</span>
        <input type="number" step="any" class="text-box-active" formControlName="longitude" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Contact Number (optional)</span>
        <input
          type="text"
          class="text-box-active"
          formControlName="contact"
          inputmode="numeric"
          maxlength="10"
          autocomplete="tel"
        />
      </div>
      <div class="field">
        <span class="field-label">Alternate Contact (optional)</span>
        <input
          type="text"
          class="text-box-active"
          formControlName="altContact"
          inputmode="numeric"
          maxlength="10"
          autocomplete="tel"
        />
      </div>
    </div>

  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button
      type="submit"
      form="property-form"
      class="ac-primary-btn"
      [disabled]="isLoading || isPincodeLoading"
    >
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
